<template>
    <modal
        v-if="open"
        root-id="subscriptionActivationPasswordModals"
        root-classes="modal show"
        modal-width="modal-md"
        :ignore-escape="false"
    >
        <template #modal-container>
            <div v-if="hidePasswordForm">
                <h6 class="text-2xl md:text-3xl font-semibold leading-tight text-center mt-3">¡Felicidades!</h6>
                <p class="mt-4 text-center">Estás a solo un paso de activar tu membresía, debes crear una contraseña para empezar a usar tus beneficios.</p>
                <h6 class="mt-8 text-base text-center">Detalles de tu membresía</h6>
                <table class="w-full mt-5">
                    <tbody>
                        <tr>
                            <td class="py-1">Plan:</td>
                            <td class="px-4 py-1">{{ plan.id }}</td>
                        </tr>
                        <tr>
                            <td class="py-1">Monto:</td>
                            <td class="px-4 py-1">{{ planPrice }}</td>
                        </tr>
                        <tr>
                            <td class="py-1">Método de pago:</td>
                            <td class="px-4 py-1" v-if="isSanborns">
                                <img src="/images/sanborns.png" class="h-4" alt="Logo tienda">
                            </td>
                            <td class="px-4 py-1" v-if="isSears">
                                <img src="/images/sears.png" class="h-4" alt="Logo tienda">
                            </td>
                        </tr>
                        <tr>
                            <td class="py-1">N° de Cliente</td>
                            <td class="px-4 py-1 text-bold">{{ clientCode }}</td>
                        </tr>
                    </tbody>
                </table>

                <div class="flex justify-center mt-6">
                    <a href="#" @click="showPasswordForm" class="inline-block px-12 py-3 btn btn-green">Crear contraseña</a>
                </div>
            </div>

            <div v-else>
                <h6 class="text-2xl md:text-3xl font-semibold leading-tight text-center mt-3">Crear contraseña</h6>
                <form id="password-submit" @submit.prevent="submitPassword" class="mt-6">
                    <div class="first:mt-0 mt-4">
                        <label class="text-gray-500">Contraseña nueva</label>
                        <password-toggle>
                            <input
                                id="password"
                                type="password"
                                ref="passwordInput"
                                class="form-input block w-full py-3 rounded leading-5 bg-teal-100 border border-teal-200 placeholder-gray-400 focus:outline-none focus:border-teal-500 focus:shadow-none sm:text-sm transition duration-150 ease-in-out mt-2"
                                autocomplete="off"
                                placeholder="Escribe tu nueva contraseña"
                                @input="fillPassword($event.target.value)"
                                :value="form.password"
                            />
                        </password-toggle>
                    </div>
                    <div class="first:mt-0 mt-4">
                        <label class="text-gray-500">Confirmar contraseña</label>
                        <password-toggle>
                            <input
                                id="password-confirmation"
                                type="password"
                                class="form-input block w-full py-3 rounded leading-5 bg-teal-100 border border-teal-200 placeholder-gray-400 focus:outline-none focus:border-teal-500 focus:shadow-none sm:text-sm transition duration-150 ease-in-out mt-2"
                                autocomplete="off"
                                placeholder="Confirma tu nueva contraseña"
                                @input="fillPasswordConfirmation($event.target.value)"
                                :value="form.password_confirmation"
                            />
                        </password-toggle>
                    </div>
                    <div class="mt-4">
                        <div class="password-check grid grid-cols-1 gap-y-px text-gray-400">
                            <div
                                class="col-span-1"
                                :class="{
                                    passed: passwordValidator.isUpperAndLowercase,
                                    error: form.password.length > 0 && !passwordValidator.isUpperAndLowercase,
                                }"
                                id="password-is-upper-and-lowercase"
                            >
                                <span class="text-xs">● Una mayúscula y una minúscula</span>
                            </div>
                            <div
                                class="col-span-1"
                                :class="{
                                    passed: passwordValidator.hasANumber,
                                    error: form.password.length > 0 && !passwordValidator.hasANumber,
                                }"
                                id="password-has-a-number"
                            >
                                <span class="text-xs">● Un número</span>
                            </div>
                            <div
                                class="col-span-1"
                                :class="{
                                    passed: passwordValidator.isLongEnough,
                                    error: form.password.length > 0 && !passwordValidator.isLongEnough,
                                }"
                                id="password-is-long-enough"
                            >
                                <span class="text-xs">● Mínimo 8 caracteres</span>
                            </div>
                            <div
                                class="col-span-1"
                                :class="{
                                    passed: passwordValidator.isConfirmed,
                                    error: form.password.length > 0 && !passwordValidator.isConfirmed,
                                }"
                                id="password-is-confirmed"
                            >
                                <span class="text-xs">● Confirma tu contraseña</span>
                            </div>
                        </div>
                    </div>

                    <div class="flex justify-center mt-8">
                        <button class="inline-block px-12 py-3 btn btn-green">Crear contraseña</button>
                    </div>
                </form>
            </div>

            <div class="bg-gray-100 rounded-md mt-5 p-5">
                <p class="text-xs text-gray-500">Durante tu periodo de prueba podrás usar todos los beneficios que Círculo Plus tiene para ti, como descuentos exclusivos en tiendas Sanborns y SEARS, promociones con aliados comerciales en toda la república, entradas al cine y otros eventos gratis.</p>
                <p class="text-xs text-gray-500 mt-3">Este programa no tiene periodos forzosos, puedes cancelarlo en cualquier momento en nuestro Centro de Atención a Clientes Círculo Plus o en la sección Mi cuenta. ¿Necesitas ayuda? Centro de Atención a Clientes Círculo Plus: <a href="tel:5555406843" class="font-semibold inline-block">55 5540 6843</a>, <a href="mailto:contacto@circulo.plus" class="font-semibold inline-block">contacto@circulo.plus</a> o Whatsapp:
                <a href="https://wa.link/ibh79a" class="font-semibold inline-block" target="_blank" rel="nofollow noopener noreferrer">55 2846 6430</a
                >. Horario de atención: lunes a sábado de 9:00 a 21:00 horas y domingo de 9:00 a 20:00 horas (tiempo del Centro).</p>
            </div>
        </template>
    </modal>
</template>
<script>
import Modal from './Modal';
import Plans from './Plans';
import Form from '../support/Form';
import PasswordToggle from './PasswordToggle';
import PasswordValidator from '../support/PasswordValidator';

export default {
    components: {
        Modal,
        PasswordToggle
    },

    props: ['clientCode', 'isSanborns', 'isSears', 'plan'],

    data() {
        return {
            open: true,
            hidePasswordForm: true,
            form: new Form({
                password: '',
                password_confirmation: '',
            }),
            passwordValidator: new PasswordValidator(),
        };
    },

    computed: {
        planPrice() {
            return "$" + this.plan.pricing / 100 + " MXN"
        },
    },

    methods: {
        fillPassword(password) {
            this.form.password = password;
            this.passwordValidator.run(this.form.password, this.form.password_confirmation);
        },

        fillPasswordConfirmation(password) {
            this.form.password_confirmation = password;
            this.passwordValidator.run(this.form.password, this.form.password_confirmation);
        },

        showPasswordForm() {
            this.hidePasswordForm = false
        },

        submitPassword() {
            this.form.post('/update-password').then((response) => {
                this.$emit('passwordSet');
            });
        }
    }
};
</script>
